import { Component } from '@angular/core';
import { CoreProvider } from 'src/app/services/core';
import { OkmodalPage } from '../private/pages/common-module/pages/okmodal/okmodal';
import { UpdatemodalPage } from '../private/pages/common-module/pages/updatemodal/updatemodal';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  constructor(private core: CoreProvider) {}

  openOkModal() {
    OkmodalPage.Open(this.core, { message: 'TEST OKMODAL', timeout:1000000 }, () => {
      console.log('dissmiissed');
    });
  }

  openVersion = () => UpdatemodalPage.Open(this.core);

}
